'use client';

import { TO_TOP_SCROLL_THRESHOLD } from '@/constants';
import { Transition } from '@headlessui/react';
import { TdsArrowIcon } from '@tallinn-arvudes/ui/atoms/icons/arrow-icon';
import { Button } from '@tallinn-arvudes/ui/tallinn-design/Button';
import { cn } from '@tallinn-arvudes/ui/utils';
import React, { useEffect, useState } from 'react';

export const ScrollButton = () => {
  const [visible, setVisible] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    const toggleVisible = () => {
      const scrolled = document.documentElement.scrollTop;
      setVisible(scrolled > TO_TOP_SCROLL_THRESHOLD);
    };

    window.addEventListener('scroll', toggleVisible);

    return () => {
      window.removeEventListener('scroll', toggleVisible);
    };
  }, []);

  return (
    <Transition show={visible}>
      <Button
        compact
        className={cn(
          'transition-all motion-reduce:transition-none opacity-200 data-[closed]:opacity-0 fixed right-4 bottom-4',
        )}
        onClick={scrollToTop}
        icon={<TdsArrowIcon />}
        iconPosition="right"
      >
        Üles
      </Button>
    </Transition>
  );
};
